<template>
  <v-fade-transition>
    <section>
      <v-layout justify-space-between style="padding-right: 2px">
        <p class="mb-0 font-weight-bold">OTP를 입력해주세요.</p>
      </v-layout>
      <FormValidationInput
        :inputValue.sync="inputValue"
        :valid="{ name: 'OTP 코드', rules: 'required' }"
        autocomplete="one-time-code"
        placeholder="인증번호"
        tabindex="1"
        autofocus
        clearable
        oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1').substring(0,6)"
        @update:inputValue="$emit('update:otp', $event)"
      />
    </section>
  </v-fade-transition>
</template>

<script>
export default {
  props: {
    otp: {
      type: String,
    },
  },
  components: {
    FormValidationInput: () => import('@/components/common/form/FormValidationInput.vue'),
  },
  data() {
    return {
      inputValue: '',
    }
  },
}
</script>
